import { render, staticRenderFns } from "./mobileTabbedPage.vue?vue&type=template&id=bca067f0&scoped=true&"
import script from "./mobileTabbedPage.vue?vue&type=script&lang=js&"
export * from "./mobileTabbedPage.vue?vue&type=script&lang=js&"
import style0 from "./mobileTabbedPage.vue?vue&type=style&index=0&id=bca067f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca067f0",
  null
  
)

export default component.exports